<template>
  <div>
    <top></top>
    <el-carousel style="width: 100%;height: 320px;" indicator-position="none">
      <el-carousel-item style="width: 100%;height: 320px;">
        <img class="swiper-img" src="../../../static/images/swiper3.jpg"/>
      </el-carousel-item>
    </el-carousel>
    <menutree :menuchild="menuchild" checkMenu="1" :rightBars="rightBars"></menutree>
    <!-- 地图 -->
    <div class="map_box">
      <div class="map_div">
          <baidu-map
            class="map-wrap"
            :center="mapData.center"
            :zoom="mapData.zoom"
            @ready="setPoint"
          >
          <bm-marker position="{lng: 120.185039, lat: 30.283774}"></bm-marker>
          </baidu-map>
      </div>
    </div>
    <!-- 联系方式 -->
    <div class="contact_box">
      <div class="contact_div">
        <div class="contact_left">
          <div class="contact_title">
            联系方式
          </div>
          <div class="contact_cont" style="line-height: 50px;margin-top: 30px;">
            公司地址：浙江省杭州市临平区星桥街道星桥北路64号4幢601室
            <br>
            联系方式：0571-89150039
            <br>
            传真号码：0571-89150039
            <br>
            邮政编号：311100
          </div>
          <!-- <div class="contact_cont">
            业务联系人：
            <br>
            （安全评价）蒋永成 15990171710    jyc@hzdyjc.com
            <br>
            （职业卫生）沈勇傲 13957333714   651492103@qq.com
            <br>
            （环保检测）陈国平 13093766170   276025466@qq.com
          </div> -->
         <!-- <div class="contact_cont">
            <img  src="http://www.zjdyah.com/KUpload/image/20190430/20190430170138_2280.jpg"/>
            <div style="margin-left: 20px;">扫一扫，关注微信公众号</div>
          </div> -->
        </div>
        <div class="contact_right">
          <div class="contact_title">
            预约  /  留言
          </div>
          <div class="contact_cont">
            欲了解更多或商务合作，请留言给我们
          </div>
          <div class="contact_inputs">
            <input style="height: 50px;" v-model="name" maxlength="10" placeholder="您的名字" class="contact_input"/>
            <input style="height: 50px;" v-model="mobile" maxlength="20" placeholder="您的电话" class="contact_input"/>
            <textarea style="height: 150px;" v-model="description" maxlength="200" placeholder="简单描述" class="contact_input"></textarea>
            <div class="submit_bt pointer" @click="submit()">
              提交
            </div>
          </div>
        </div>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import top from '@/components/top.vue';
import menutree from '@/components/menutree.vue';
import bottom from '@/components/bottom.vue';
export default {
  components:{top,menutree,bottom},
  data () {
    return {
      name:'',
      mobile:'',
      description:'',
      //商家信息(包含坐标信息)
      businessDetail:{},
      //地图数据
      mapData: {
        //中心坐标
        center: { lng: 120.263659, lat: 30.408137 },
        //缩放级别
        zoom: 12
      },
      //BMap类
      BMap: null,
      //地图对象
      map: null,
      menuchild:[{
        lable:'联系我们',
        value:'1',
        path:'/contactUs'
      }],
      rightBars:[{
        lable:'首页',
        path:'/',
      },{
        lable:'联系我们',
        path:'',
      },{
        lable:'联系我们',
        path:'',
      }]
    }
  },
  // mounted() {
  //   this.setPoint()
  // },
  methods:{
    submit(){
      if(!this.name){
        this.$message.error('请填写你的姓名');
        return false;
      }
      if(!this.mobile){
        this.$message.error('请填写你的联系方式');
        return false;
      }
      const url=`https://api.hzshjc.com/index/appointment/add`;
      let data = {
        name:this.name,
        mobile:this.mobile,
        description:this.description
      }
      this.$axios({
        method:'post',
        url:url,
        data:data
      }).then(res=>{
        if(res.data.code=='200'){
          this.$message.success('提交成功，稍后会有工作人员与您联系！')
          this.name = '';
          this.mobile = '';
          this.description = '';
        }
      })
    },
    setPoint({BMap,map}){
      this.BMap = BMap;
      this.map = map;
      let marker = new BMap.Marker(
        new BMap.Point(
           this.mapData.center.lng,
           this.mapData.center.lat
        )
      )
      //将标记添加到地图上
      map.addOverlay(marker)
      map.enableScrollWheelZoom();
    }

  }
}
</script>

<style scope lang="less">
  .swiper-img{
    width: 100%;
    height: 320px;
  }
  .map_box{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px 0;
    .map_div{
      width: 1180px;
      padding: 10px;
      height: 300px;
      border: 1px solid #eee;
    }
  }
  .contact_box{
    width: 100%;
    display: flex;
    justify-content: center;
    margin:20px 0 50px 0;
    .contact_div{
      width: 1200px;
      display: flex;
      justify-content: space-between;
      .contact_title{
        color: #00a73c;
        font-size: 24px;
      }
      .contact_cont{
        color: #666666;
        line-height: 26px;
        font-size: 14px;
        background-position: left center;
        background-repeat: no-repeat;
        margin-top: 10px;
        img{
          height: 200px;
          width: 200px;
        }
      }
      .contact_cont::selection{
        background-color: #00a73c;
        color: #fff;
      }
      .contact_right{
        width: 700px;
        .contact_inputs{
          margin-top: 30px;
          .contact_input{
            width: 700px;
            outline:none;
            border: none;
            color: #666;
            font-size: 14px;
            border-bottom: 1px solid #e0e0e0;
            margin-bottom: 20px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
          }
          .contact_input:hover{
            border-bottom: 1px solid #00a73c;
            color: #00a73c;
          }
          .submit_bt{
            z-index: 2;
                display: block;
                width: 130px;
                height: 42px;
                line-height: 42px;
                font-size: 16px;
                font-weight: bold;
                text-transform: uppercase;
                background-color: #00a73c;
                position: relative;
                text-align: center;
                overflow: hidden;
                box-sizing: border-box;
                -moz-box-sizing: border-box;
                -webkit-box-sizing: border-box;
                border-radius: 3px;
                -moz-border-radius: 3px;
                -webkit-border-radius: 3px;
                -o-border-radius: 3px;
                color: #fff;
          }
        }
      }
    }
  }
  .map-wrap{
    height: 100%;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/concerning/contactUs.vue